import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import basicParameterFormMeta, { IBasicParameterFormMeta } from "./basicParameterFormMeta";
import inactiveAccountParametersFormMeta, { I_InactiveAccountParametersFormMeta } from "./inactiveAccountParametersFormMeta";

export interface IPrePaidBasicParametersFormMeta extends IBasicParameterFormMeta, I_InactiveAccountParametersFormMeta {
  
  schema: any;
}

let basicParametersFormMeta = {} as IPrePaidBasicParametersFormMeta;

basicParametersFormMeta = { ...basicParametersFormMeta,
  ...basicParameterFormMeta, ...inactiveAccountParametersFormMeta
};

basicParametersFormMeta.schema = yup.object().shape(getValidationSchema(basicParametersFormMeta));

export default basicParametersFormMeta;